var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-sm",class:_vm.margin},[_c('div',{staticClass:"text-gray-500 mb-1"},[_vm._t("left")],2),_c('div',{staticClass:"font-semibold"},[_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }